
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLigthSleetColour as ObiLightningLigthSleetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-ligth-sleet-colour.js';
 
 
 

 
 export const ObiLightningLigthSleetColour = createComponent({
   react: React,
   tagName: 'obi-lightning-ligth-sleet-colour',
   elementClass: ObiLightningLigthSleetColourElement,
   events: {
     
   }
  });
 
 